var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table is-fullwidth is-hoverable",attrs:{"id":"timber-table-full-result"}},[_vm._m(0),_c('tbody',[_vm._l((_vm.woodResults),function(woodType,index){return [_vm._l((woodType.qualities),function(quality,indexQuality){return [(quality.volume > 0)?[_vm._l((quality.strengthClasses),function(strengthClass,indexStrength){return [(strengthClass.volume > 0)?[(woodType.volume > 0)?_c('tr',{key:woodType.name +
                    '_(' +
                    index +
                    ')_' +
                    quality.name +
                    '_' +
                    'strength' +
                    indexStrength +
                    '_volume'},[(indexQuality === 0 && indexStrength === 0)?_c('th',{staticClass:"has-text-weight-bold",attrs:{"rowspan":_vm.getAmountOfRowsForWoodType(woodType)}},[_vm._v(_vm._s(woodType.name))]):_vm._e(),(indexStrength === 0)?_c('td',{key:woodType.name + '_quality_' + indexQuality,attrs:{"rowspan":_vm.getAmountOfRowsForQuality(quality, woodType.qualities.length)}},[_vm._v(_vm._s(quality.name))]):_vm._e(),_c('td',{key:woodType.name +
                      '_' +
                      quality.name +
                      '_' +
                      'strength' +
                      indexStrength +
                      '_name',staticClass:"has-text-centered"},[_vm._v(_vm._s(strengthClass.name))]),_c('td',{key:woodType.name +
                      '_' +
                      quality.name +
                      '_' +
                      'strength' +
                      indexStrength +
                      '_volume',attrs:{"data-cy":woodType.name +
                      '_' +
                      quality.name +
                      '_' +
                      strengthClass.name + 
                      '_volume'}},[_vm._v(_vm._s(_vm.round(strengthClass.volume))+" m³ ")]),_c('td',[_c('small',[_vm._v(_vm._s(strengthClass.quantity)+" Stk.")])])]):_vm._e(),(indexStrength === quality.strengthClasses.length - 1 
                && quality.strengthClasses.length > 1
                && woodType.qualities.length > 1)?[_c('tr',{key:woodType.name + 
                      '_' +
                      quality.name +
                      '_' +
                      'strength' +
                      indexStrength +
                      '_row_sum',staticClass:"quality-total-volume"},[_c('th',[_c('span',{staticClass:"is-hidden"},[_vm._v("Summe "+_vm._s(quality.name))])]),_c('th',{attrs:{"data-cy":woodType.name +
                      '_' +
                      quality.name + 
                      '_volume'}},[_vm._v(_vm._s(_vm.round(quality.volume))+" m³ ")]),_c('th',[_c('small',[_vm._v(_vm._s(quality.quantity)+" Stk.")])])])]:_vm._e(),(
                  indexQuality === woodType.qualities.length - 1 &&
                    indexStrength === quality.strengthClasses.length - 1
                )?[_c('tr',{key:woodType.name +
                      '_' +
                      quality.name +
                      '_' +
                      'strength' +
                      indexStrength +
                      '_row',staticClass:"wood-type-total-volume"},[_c('th',{attrs:{"colspan":"2"}},[_vm._v("Gesamt")]),_c('th',{attrs:{"data-cy":woodType.name + '_volume'}},[_vm._v(_vm._s(_vm.round(woodType.volume))+" m³ ")]),_c('th',[_c('small',[_vm._v(_vm._s(woodType.quantity)+" Stk.")])])])]:_vm._e()]:_vm._e()]})]:_vm._e()]})]})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('td',[_vm._v("Holzart")]),_c('td',[_vm._v("Qualität")]),_c('td',[_vm._v("Stärkeklasse")]),_c('td',{staticStyle:{"min-width":"5.6em"}},[_vm._v("Summe")]),_c('td',[_vm._v("Anzahl")])])])}]

export { render, staticRenderFns }